import * as S from './styles'
import { useOurServicesContainer } from './useOurServices'
import {
  AdaptedProcessesIcon,
  HandGearIcon,
  MagnifierPeopleIcon,
  PeopleStarIcon,
} from '@/assets/icons'
import { Text, Card } from '@/components'

const ICONS_MAP = Object.freeze({
  adaptedProcesses: AdaptedProcessesIcon,
  handGear: HandGearIcon,
  magnifierPeople: MagnifierPeopleIcon,
  peopleStar: PeopleStarIcon,
})

export const OurServicesContainer: React.FC = () => {
  const { data } = useOurServicesContainer()

  return (
    <S.Container>
      <Text color="white" align="center" fontFamily="primary" size="h3">
        {data.title}
      </Text>
      <S.Services>
        {data.services.map((service) => (
          <Card
            icon={{
              src: ICONS_MAP[service.icon.name],
              alt: service.icon.alt,
            }}
            title={service.title}
            description={service.description}
          />
        ))}
      </S.Services>
    </S.Container>
  )
}
